import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class RubroVendedorService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    obtenerRubrosVendedor(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: rubro_vendedorInputType) {
          rubro_vendedor {
            obtenerRubrosVendedor(entidad: $entidad) {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                rut_empresa
                sucursal_codigo
                vendedor_codigo
                rubro_codigo
                rubro_nombre
                asignado
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.rubro_vendedor.obtenerRubrosVendedor;
            callback({ mensajes, respuesta });
        });
    }
    guardarListaRubro(inputParams, callback) {
        this.gqlclient.mutate({
            mutation: gql `
        mutation ($entidad: rubro_vendedorInputType) {
          rubro_vendedor {
            guardarListaRubro(entidad: $entidad) {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                rut_empresa
                sucursal_codigo
                vendedor_codigo
                rubro_codigo
                fecha_registro
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.rubro_vendedor.guardarListaRubro;
            callback({ mensajes, respuesta });
        });
    }
}
RubroVendedorService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RubroVendedorService_Factory() { return new RubroVendedorService(i0.ɵɵinject(i1.GraphQLClient)); }, token: RubroVendedorService, providedIn: "root" });
